import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { MemberService } from './../../../../rest/api/member.service';
import { AuthService } from './../../../../services/auth.service';

@Component({
  selector: 'app-delete-floorplan-hotspot-modal',
  templateUrl: './delete-floorplan-hotspot-modal.component.html',
  styleUrls: ['./delete-floorplan-hotspot-modal.component.scss']
})
export class DeleteFloorplanHotspotModalComponent implements OnInit, OnChanges {
  @Input() editHotspots;
  @Output() modalCloseEmit = new EventEmitter();
  isSubmitted = false;
  accessToken: any;
  deleteError;
  deleteSuccess;
  constructor(
    public memberService: MemberService,
    public authService: AuthService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.resetErrorValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.editHotspots && changes.editHotspots.currentValue) {
      this.resetErrorValues();
    }
  }

  deleteHotspots(editHotspots) {
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.deleteHotspotsEmit(editHotspots);
  }

  deleteHotspotsEmit(editHotspots) {
    this.deleteError = undefined;
    this.memberService.deleteFloorplanHotspot({
      Authorization: this.accessToken,
      id: editHotspots.uuid
    }).subscribe((response: any) => {
      this.deleteSuccess = 'Hotspot was successfully deleted.';
      setTimeout(() => {
        this.modalCloseEmit.emit(editHotspots);
      }, 2000);
    }, err => {
      if (err.error && err.error.error) {
        this.deleteError = err.error.error;
      } else {
        this.deleteError = 'There was error while deleting hotspot.';
      }
    });
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.deleteSuccess = undefined;
    this.deleteError = undefined;
  }

  closeModal() {
    this.modalCloseEmit.emit(undefined);
  }

}
